import { emotionDescription } from '../data/emotionsTagDescription'

export default function getEmoticonDescription(icon: string, locale: string) {
  // @ts-ignore
  const tem = emotionDescription[icon]
  if (!tem) return []
  if (locale === 'ko') {
    // @ts-ignore
    return tem.name_ko
  }
  // @ts-ignore
  return tem.name_en
}
